import { render } from "./ExploreEight.vue?vue&type=template&id=1f68e4c2"
import script from "./ExploreEight.vue?vue&type=script&lang=js"
export * from "./ExploreEight.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__